import React from 'react';
import Dashboard from '../components/Dashboard';
import CardManagement from '../components/CardManagement';
import TemporaryCardBlock from '../components/TemporaryCardBlock';


export default function Main() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100">
      <main>
        <Dashboard />
      </main>
     
    </div>
  );
}